import _pickBy from "lodash/pickBy";
import _forEach from "lodash/forEach";
import "core-js/modules/es.object.assign.js";
/**
 * Merge default config with config for each active breakpoint.
 * @param {object} defaultConfig The base config to use.
 * @param {object} breakpointConfig Object with config for each breakpoint by key name.
 * @param {object} breakpoints Object with key of breakpoint name and boolean value of active.
 * @return {object}
 */
function getConfig(defaultConfig, breakpointConfig, breakpoints) {
  var config = Object.assign({}, defaultConfig);
  _forEach(_pickBy(breakpoints), function (value, key) {
    Object.assign(config, breakpointConfig[key]);
  });
  return config;
}
export var Responsive = {
  getConfig: getConfig
};